<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/wiGPQu/image/whatthewindOrig.jpg?1684515191864" alt="This image is the cover for the book What the Wind Can Tell You"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">What the Wind Can Tell You
      </h1>
      <p class="bookDescription body article font2">
        <p>Isabelle is fascinated by wind. And this year, she’s determined to win the middle school science fair with her wind machine. She’s just as determined to have her brother, Julian, who lives with a severe form of epilepsy and uses a wheelchair, serve as her assistant. But after Julian has a grand seizure, everything changes. Isabelle is suddenly granted entry into Las Brisas, a magical world where Julian’s physical limitations disappear, and one, she discovers, that he visits every night. The more Isabelle explores Las Brisas, the more possibilities she sees—for Julian, and for herself—and the more she finds herself at odds with her parents. Debut author Sarah Marie A. Jette has told, with remarkable insight and humor, a powerful story of a family struggling to love without fear.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sarah Marie Jette
      </h2>
      
      <p class="authorDescription body article">Sarah Marie A. Jette grew up in Lewiston, Maine, in a house filled with books. A graduate of Mount Holyoke College, she served in the Peace Corps in Mongolia, studied rehabilitation counseling, and now has what she considers the best job in the world: teaching fourth-graders. When she’s not writing, she’s crafting with her three children, sewing her own clothes, and snuggling with her cats. Sarah Marie lives in Belmont, Massachusetts. What the Wind Can Tell You is her first novel.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?ef8e99de